// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Bbde6","link":"Header_link__lbWBj","logo-container":"Header_logo-container__joJJo","logo":"Header_logo__nCjsB"};